<template>
  <BaseTableView
    :head="target !== 'manual' ? tableHeadTrigger : tableHead"
    :class="$vuetify.breakpoint.xlOnly ? 'table' : ''"
  >
    <SettingsPushNotificationsTableItem
      v-for="item in items"
      :key="item.id"
      :item="item"
      :onDownloadPageData="onDownloadPageData"
      :target="target"
    />
  </BaseTableView>
</template>

<script>
import SettingsPushNotificationsTableItem from 'components/setting/pushNotifications/SettingsPushNotificationsTableItem'
export default {
  name: 'SettingsPushNotificationsTable',
  props: {
    items: Array,
    onDownloadPageData: Function,
    target: String,
  },
  components: { SettingsPushNotificationsTableItem },
  data() {
    return {}
  },
  computed: {
    tableHead() {
      return [
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['theme'],
          sort: {
            name: 'title',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'title'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['body'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['created_at'],
          sort: {
            name: 'created_at',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'created_at'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['author'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['status'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['recipients'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['type'],
        },
        { text: this.localStorage.translations.pages['setting-push_notifications'].main['date_start'] + '\n' + this.localStorage.translations.pages['setting-push_notifications'].main['date_end'] },
        {text: '', active: true},
      ]
    },
    tableHeadTrigger() {
      return [
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['theme'],
          sort: {
            name: 'title',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'title'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['body'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['created_at'],
          sort: {
            name: 'created_at',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'created_at'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['author'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['status'],
        },
        {
          text: this.target === 'projects'
            ? this.localStorage.translations.pages['setting-push_notifications'].main['projects']
            : this.localStorage.translations.pages['setting-push_notifications'].main['recipients'],
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['trigger'],
          sort: {
            name: 'trigger',
            value:
              this.$route.query.sort_param && this.$route.query.sort_param === 'trigger'
                ? this.$route.query.sort_value && this.$route.query.sort_value === 'desc'
                  ? 'asc'
                  : 'desc'
                : 'desc',
          },
        },
        {
          text: this.localStorage.translations.pages['setting-push_notifications'].main['type'],
        },
        { text: this.localStorage.translations.pages['setting-push_notifications'].main['time_start'] + '\n' + this.localStorage.translations.pages['setting-push_notifications'].main['time_end'] },
        { text: '', active: true },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.table:deep() {
  tr {
    td {
      &.td {
        &-title,
        &-body {
          width: 150px;
        }
        &-date,
        &-author {
          width: 150px;
        }
        &-status {
          width: 100px;
        }
        &-recipients {
          width: 120px;
        }
        &-trigger {
          width: 150px;
        }
        &-type {
          width: 135px;
        }
        &-active {
          width: 100px;
        }
        &-buttons {
          width: 100px;
        }
      }
    }
  }
}
</style>
